<mat-toolbar>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-xs="space-between center" fxFlex>
    </div>
</mat-toolbar>
